
import citiesAndStates from "./iran_cities_with_coordinates.json"

export const getCities = (cityToFind) =>  citiesAndStates.filter(city => city.name === cityToFind).pop()?.cities;

export const getProvince = () => citiesAndStates;